import { cn } from "@/ds/utils";
import type { Option } from "@/lib/common/Option";
import { cva } from "class-variance-authority";

const optionBarClassName = "p-0.75 flex items-center justify-between gap-1 whitespace-nowrap rounded-md text-xs font-medium outline-none border shadow-xs bg-input/30 dark:border-input";
const optionBarButtonVariants = cva(
	"grow transition-all cursor-pointer rounded-sm basis-0 h-7 leading-6.5 text-center border border-transparent",
	{
		variants: {
			active: {
				true: "border shadow dark:shadow-none bg-background dark:bg-accent dark:border-input",
				false: "hover:bg-accent"
			}
		}
	}
);

export interface OptionBarProps<T extends string> {
	options: Option<T>[];
	value: T;
	onChange: (value: T) => void;
	className?: string;
}

export const OptionBar = <T extends string>(props: OptionBarProps<T>) => {
	const {
		options,
		value,
		onChange,
		className
	} = props;

	return (
		<div className={cn(optionBarClassName, className)}>
			{
				options.map(x => (
					<button
						key={x.value}
						type="button"
						onClick={() => onChange(x.value)}
						className={optionBarButtonVariants({ active: x.value === value })}>
						{x.label}
					</button>
				))
			}
		</div>
	);
};
